import * as ko from "knockout";
import {IFormTemplate, IMessageData} from '../../index';
import {global} from "../../appContext";
import {MAX_RESULTS_PER_PAGE} from "../../constants";
import PromiseRequest from "../../req/PromiseRequest";
import {createErrorMessage, decodeAndStripHtml} from "../../util/misc";
import {getSearchParams} from "../../util/request";
import {REQUEST_MESSAGE} from "../../constants/Language";
import {getHash} from "../../constants/RouteDefinitions";
import form_templateHtml from './form-template.html?raw';

export let template = form_templateHtml;

interface IParams {
    id: number
    showIcon?: boolean
}

interface IFormDataInterface {
    name: string,
    href?: string,
    icon?: string,
    onClick?: Function
};

export class viewModel {
    private readonly messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    private readonly isReady: KnockoutObservable<boolean | null> = ko.observable(null);
    private readonly req_searchformtemplate: PromiseRequest = global.getPromiseRequest('searchformtemplate');
    private readonly data: KnockoutObservable<IFormDataInterface | null> = ko.observable(null);

    constructor(private params: IParams) {
        this.init();
    }

    private init() {
        if (!this.params.id) {
            return;
        }
        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE});

        this.req_searchformtemplate
            .request(getSearchParams({
                resultsprpage: MAX_RESULTS_PER_PAGE,
                sortcol: "name",
            }))
            .then((data: IFormTemplate[]) => {
                const d = data.find(o => o.id == this.params.id);
                if (!d) {
                    this.messageData({message: 'data not available', type: 'warning'});
                    return;
                }
                const obj: IFormDataInterface = {
                    name: decodeAndStripHtml(d.name),
                }
                if (d.v2form) {
                    obj.onClick = () => global.eHubManager.start({form: d.id})
                } else {
                    const href = getHash('formtemplatedetails', d) ?? undefined;
                    if (href !== undefined) {
                        obj.href = href;
                    }
                }
                this.data(obj);
                this.messageData(null);
                this.isReady(true);
            })
            .catch((reason: string) => {
                this.messageData(createErrorMessage(String(reason)))
            })
        ;
    }

    dispose() {
        this.req_searchformtemplate.abort();
    }
}
